import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext, useMemo, useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import { Image } from '../../Image/rn';
import ImageFailure from '../../../assets/images/rn/ImageFailure';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { AgentUploadLoading } from '../../Loader/rn';
import { OrderCardType, orderCardStyleMap } from '../../OrderList/rn';
import { useLocale } from '../../LocaleProvider/rn';
import { ITEMS_TEXT, ITEM_TEXT, TOTAL_TEXT, DELIVERED_BY_TEXT, COPY_TEXT } from '../../../utils/constants';
import * as RNStyle from '../../../styles/rn';
import { FONT_WEIGHT_REGULAR } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import UIOptimisationOrderDefaultImg from '../../../assets/images/rn/UIOptimisationOrderDefaultImg';
export var Order = function Order(props) {
  // 注释的代码新版本放开注释
  var action = props.action,
    style = props.style,
    title = props.title,
    price = props.price,
    image = props.image,
    specification = props.specification,
    handleClick = props.handleClick,
    _props$itemCount = props.itemCount,
    itemCount = _props$itemCount === void 0 ? 1 : _props$itemCount,
    itemsText = props.itemsText,
    itemText = props.itemText,
    orderStatusText = props.orderStatusText,
    handleStatusClick = props.handleStatusClick,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    _props$orderCardType = props.orderCardType,
    orderCardType = _props$orderCardType === void 0 ? OrderCardType.oldCarousel : _props$orderCardType,
    totalPrice = props.totalPrice,
    totalText = props.totalText,
    _props$selectOrderTex = props.selectOrderText,
    selectOrderText = _props$selectOrderTex === void 0 ? '' : _props$selectOrderTex,
    allowSelectBtn = props.allowSelectBtn,
    _props$showTotalText = props.showTotalText,
    showTotalText = _props$showTotalText === void 0 ? true : _props$showTotalText,
    _props$showOneLineTit = props.showOneLineTitle,
    showOneLineTitle = _props$showOneLineTit === void 0 ? false : _props$showOneLineTit,
    createdTime = props.createdTime,
    deliverer = props.deliverer,
    copyText = props.copyText,
    orderSn = props.orderSn,
    showPredictedText = props.showPredictedText,
    predictedText = props.predictedText,
    isUIOptimisationHotQuestion = props.isUIOptimisationHotQuestion,
    milestone = props.milestone;
  var context = useContext(ConfigContext);
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgError = _useState2[0],
    setImgError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    priceIsMultiline = _useState4[0],
    setPriceIsMultiline = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    orderInfoIsMultiline = _useState6[0],
    setOrderInfoIsMultiline = _useState6[1];
  var handleCardClick = function handleCardClick() {
    var _context$eventEmitter, _context$eventEmitter2;
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      action: action
    }));
    handleClick === null || handleClick === void 0 ? void 0 : handleClick();
  };
  var handleCopyClick = function handleCopyClick() {
    var _props$handleCopyClic;
    (_props$handleCopyClic = props.handleCopyClick) === null || _props$handleCopyClic === void 0 ? void 0 : _props$handleCopyClic.call(props);
  };
  var getOrderCardStyleMapStyle = function getOrderCardStyleMapStyle() {
    var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return styles["order-container-".concat(orderCardStyleMap[orderCardType]).concat(suffix ? '-' : '').concat(suffix)];
  };
  var isTitleIsOrderInfoNameOneLineStyle = useMemo(function () {
    return !!(orderCardType === OrderCardType.foodCardInList || showOneLineTitle || showPredictedText && predictedText);
  }, [orderCardType, showOneLineTitle, showPredictedText, predictedText]);
  var handleOrderStatusTextLayout = function handleOrderStatusTextLayout(e) {
    var lines = e.nativeEvent.lines;
    setOrderInfoIsMultiline(lines.length > 1);
  };
  var handleOrderPriceTextLayout = function handleOrderPriceTextLayout(e) {
    var lines = e.nativeEvent.lines;
    setPriceIsMultiline(lines.length > 1);
  };
  var renderOrderInfo = function renderOrderInfo() {
    if (isUIOptimisationHotQuestion) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: [styles['order-info-detail'], getOrderCardStyleMapStyle('order-info-detail'), styles['order-info-detail-ui-optimisation-hot-question']]
      }, /*#__PURE__*/React.createElement(Text, {
        style: [styles['order-info-detail-item'], styles['order-info-detail-item-ui-optimisation-hot-question']],
        onTextLayout: handleOrderPriceTextLayout
      }, itemCount, " ", Number(itemCount) > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT), priceIsMultiline ? '\n' : ', ', totalText || trans(TOTAL_TEXT), ": ", totalPrice)), /*#__PURE__*/React.createElement(View, {
        style: [styles['order-info-wrap'], getOrderCardStyleMapStyle('order-info-wrap'), styles['order-info-wrap-ui-optimisation-hot-question']]
      }, milestone !== null && milestone !== void 0 && milestone.icon ? milestone === null || milestone === void 0 ? void 0 : milestone.icon : null, /*#__PURE__*/React.createElement(Text, {
        style: [styles['order-info-wrap-status'], styles['order-info-wrap-status-ui-optimisation-hot-question']],
        onTextLayout: handleOrderStatusTextLayout
      }, milestone !== null && milestone !== void 0 && milestone.text ? milestone === null || milestone === void 0 ? void 0 : milestone.text : orderStatusText)));
    }
    if (orderCardType === OrderCardType.oldCarousel) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-specification'],
        numberOfLines: 1
      }, specification), /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-price'],
        numberOfLines: 1
      }, price));
    }
    if (orderCardType === OrderCardType.orderWithCopy) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-delivered-new'],
        numberOfLines: 1
      }, trans(DELIVERED_BY_TEXT), ": ", deliverer), /*#__PURE__*/React.createElement(View, {
        style: styles['order-info-tracing-box']
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-ordersn'],
        numberOfLines: 1
      }, orderSn, ' '), /*#__PURE__*/React.createElement(Pressable, {
        onPress: handleCopyClick
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-copy']
      }, copyText || trans(COPY_TEXT)))));
    }
    if (orderCardType === OrderCardType.smallOrder) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: [styles['order-info-detail'], getOrderCardStyleMapStyle('order-info-detail')]
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-status'],
        numberOfLines: 1
      }, orderStatusText), /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-price'],
        numberOfLines: 1
      }, /*#__PURE__*/React.createElement(Text, {
        style: [styles['order-info-detail-price-text'], getOrderCardStyleMapStyle('order-info-detail-price')]
      }, totalText || trans(TOTAL_TEXT), ":"), totalPrice)));
    }
    if (orderCardType === OrderCardType.foodCardInList) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-specification'],
        numberOfLines: 1
      }, specification), /*#__PURE__*/React.createElement(View, {
        style: styles['order-info-detail']
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-item'],
        numberOfLines: 1
      }, itemCount, " ", Number(itemCount) > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT)), /*#__PURE__*/React.createElement(Text, {
        style: [styles['order-info-detail-price'], {
          flex: 0
        }],
        numberOfLines: 1
      }, showTotalText && /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-price-text']
      }, totalText || trans(TOTAL_TEXT), ":"), totalPrice)));
    }
    if (orderCardType === OrderCardType.foodCard) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: styles['order-info-detail']
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-item'],
        numberOfLines: 1
      }, itemCount, " ", Number(itemCount) > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT)), /*#__PURE__*/React.createElement(Text, {
        style: [styles['order-info-detail-price'], {
          flex: 0
        }],
        numberOfLines: 1
      }, showTotalText && /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-price-text']
      }, totalText || trans(TOTAL_TEXT), ":"), totalPrice)), createdTime ? /*#__PURE__*/React.createElement(View, {
        style: styles['order-info-wrap']
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-wrap-time'],
        numberOfLines: 1
      }, createdTime)) : null);
    }
    if (orderCardType === OrderCardType.expeditedDelivery) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        style: [styles['order-info-detail'], getOrderCardStyleMapStyle('order-info-detail')]
      }, /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-deliver-status'],
        numberOfLines: 1
      }, orderStatusText), /*#__PURE__*/React.createElement(Text, {
        style: styles['order-info-detail-deliver'],
        numberOfLines: 1
      }, deliverer)));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: [styles['order-info-detail'], getOrderCardStyleMapStyle('order-info-detail')]
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles['order-info-detail-item'],
      numberOfLines: 1
    }, itemCount, " ", Number(itemCount) > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT)), /*#__PURE__*/React.createElement(Text, {
      style: [styles['order-info-detail-price'], getOrderCardStyleMapStyle('order-info-detail-price')],
      numberOfLines: 1
    }, orderCardType !== OrderCardType.bigCarousel && showTotalText && /*#__PURE__*/React.createElement(Text, {
      style: styles['order-info-detail-price-text']
    }, totalText || trans(TOTAL_TEXT), ":"), ' ', totalPrice)), /*#__PURE__*/React.createElement(View, {
      style: [styles['order-info-wrap'], getOrderCardStyleMapStyle('order-info-wrap')]
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles['order-info-wrap-status'],
      numberOfLines: 1
    }, orderStatusText), (orderCardType === OrderCardType.verticalList || orderCardType === OrderCardType.twoRowCarousel) && allowSelectBtn && /*#__PURE__*/React.createElement(Text, {
      style: styles['order-info-wrap-select-btn']
    }, selectOrderText)), createdTime ? /*#__PURE__*/React.createElement(Text, {
      style: styles['order-info-time'],
      numberOfLines: 1
    }, createdTime) : null);
  };
  var getOrderInfoNameNumberOfLines = function getOrderInfoNameNumberOfLines() {
    if (isUIOptimisationHotQuestion) {
      return 1;
    } else {
      return isTitleIsOrderInfoNameOneLineStyle || [OrderCardType.smallOrder, OrderCardType.expeditedDelivery].includes(orderCardType) ? 1 : 2;
    }
  };
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: function onPress() {
      return handleCardClick();
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles['order-container'], getOrderCardStyleMapStyle(), isUIOptimisationHotQuestion ? styles['order-container-ui-optimisation-hot-question'] : {}, style]
  }, loading ? /*#__PURE__*/React.createElement(AgentUploadLoading, null) : /*#__PURE__*/React.createElement(Pressable, {
    onPress: function onPress() {
      return handleStatusClick === null || handleStatusClick === void 0 ? void 0 : handleStatusClick();
    }
  }, error && /*#__PURE__*/React.createElement(ImageFailure, null)), /*#__PURE__*/React.createElement(View, {
    style: [styles['order-image'], getOrderCardStyleMapStyle('order-image'), isUIOptimisationHotQuestion ? styles['order-image-ui-optimisation-hot-question'] : {}, isUIOptimisationHotQuestion && (priceIsMultiline || orderInfoIsMultiline) ? styles['order-image-ui-optimisation-hot-question-big'] : {}]
  }, isUIOptimisationHotQuestion && imgError ? /*#__PURE__*/React.createElement(UIOptimisationOrderDefaultImg, {
    style: styles['order-image-ui-optimisation-hot-question-icon']
  }) : /*#__PURE__*/React.createElement(Image, {
    src: image,
    styles: {
      containerStyle: _objectSpread(_objectSpread({}, styles['order-image-container']), getOrderCardStyleMapStyle('order-image-container')),
      imageStyle: _objectSpread(_objectSpread({}, getOrderCardStyleMapStyle('order-image-style')), isUIOptimisationHotQuestion ? styles['order-image-style-ui-optimisation-hot-question'] : {}),
      errorSvgStyle: _objectSpread({}, getOrderCardStyleMapStyle('order-image-container-error'))
    },
    width: "100%",
    height: "100%",
    onClick: function onClick() {
      return handleCardClick();
    },
    onError: function onError() {
      return setImgError(true);
    }
  })), /*#__PURE__*/React.createElement(View, {
    style: [styles['order-info'], getOrderCardStyleMapStyle('order-info'), isUIOptimisationHotQuestion ? styles['order-info-ui-optimisation-hot-question'] : {}]
  }, showPredictedText && predictedText && !isUIOptimisationHotQuestion ? /*#__PURE__*/React.createElement(Text, {
    style: styles['order-info-recommendation']
  }, predictedText) : null, /*#__PURE__*/React.createElement(Text, {
    style: [isTitleIsOrderInfoNameOneLineStyle ? styles['order-info-name_one-line'] : [styles['order-info-name'], getOrderCardStyleMapStyle('order-info-name')], [isUIOptimisationHotQuestion ? styles['order-info-name-ui-optimisation-hot-question'] : {}]],
    numberOfLines: getOrderInfoNameNumberOfLines()
  }, title), renderOrderInfo())));
};
var uiOptimisationPriceStyle = {
  color: 'rgba(0, 0, 0, 0.54)',
  fontSize: 14,
  lineHeight: 16
};
var styles = CustomStyleSheet({
  'order-container': {
    padding: 12,
    flexDirection: 'row',
    width: RNStyle.BubbleInnerWidth,
    maxWidth: '100%',
    backgroundColor: '#fff',
    borderRadius: 12
  },
  'order-container-big-carousel': {
    width: 150,
    flexDirection: 'column'
  },
  'order-container-expedited-delivery': {
    width: '100%',
    padding: 10
  },
  'order-container-big-carousel-order-image': {
    width: 124,
    height: 125
  },
  'order-container-big-carousel-order-info': {
    marginTop: 12,
    marginLeft: 0
  },
  'order-container-big-carousel-order-info-detail': {
    marginTop: 4
  },
  'order-container-big-carousel-order-info-wrap': {
    marginTop: 10
  },
  'order-container-vertical-list-order-info-detail': {
    marginTop: 4
  },
  'order-container-small-order-order-image': {
    width: 44,
    height: 44
  },
  'order-container-small-order-order-info-detail': {
    marginTop: 14
  },
  'order-container-small-order-order-info-detail-price': _objectSpread({}, RNStyle.FONT_WEIGHT_MEDIUM),
  'order-container-small-order-order-info-name': {
    height: 'auto'
  },
  'order-container-expedited-delivery-order-info': {
    marginLeft: 8
  },
  'order-container-expedited-delivery-order-image': {
    width: 34,
    height: 34,
    borderRadius: 8,
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.09)',
    borderWidth: 1
  },
  'order-container-expedited-delivery-order-image-container': {
    borderRadius: 8,
    backgroundColor: 'transparent'
  },
  'order-container-expedited-delivery-order-image-style': {
    borderRadius: 8
  },
  'order-container-expedited-delivery-order-image-container-error': {
    textAlign: 'center',
    width: 29,
    height: 29,
    marginLeft: 1
  },
  'order-container-expedited-delivery-order-info-detail': {
    marginTop: 2
  },
  'order-container-expedited-delivery-order-info-name': {
    height: 'auto',
    fontSize: 12
  },
  'order-image': {
    textAlign: 'center',
    width: 80,
    height: 80,
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.09)'
  },
  'order-image-container': {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  // &-container {
  //   height: 100%;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //     object-fit: unset;
  'order-image-container-img': {
    width: '100%',
    height: '100%'
  },
  'order-image-container-error': {
    textAlign: 'center',
    width: 31
  },
  image__error: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fafafa'
  },
  // &.@{prefix-cls}-image__error {
  //   align-items: center;
  //   justify-content: center;
  //   background: #fafafa;
  //   img {
  //     width: 3rem;
  //     height: 3rem;
  //   }
  'image__error-img': {
    width: 48,
    height: 48
  },
  'order-info': {
    marginLeft: 12,
    overflow: 'hidden',
    flex: 1
  },
  'order-info-recommendation': {
    fontSize: 10,
    lineHeight: 12,
    color: '#26aa99',
    marginBottom: 4
  },
  'order-info-name': {
    fontSize: 14,
    lineHeight: 16,
    height: 'auto',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'order-info-name_one-line': {
    fontSize: 14,
    lineHeight: 16,
    height: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'order-info-specification': {
    fontSize: 12,
    lineHeight: 14,
    height: 14,
    marginTop: 4,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  'order-info-price': {
    fontSize: 14,
    lineHeight: 16,
    marginTop: 8,
    height: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'order-info-delivered-new': {
    marginTop: 18,
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  'order-info-tracing-box': {
    flexDirection: 'row',
    alignItems: 'center'
  },
  'order-info-ordersn': {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1
  },
  'order-info-copy': {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#26aa99',
    marginVertical: 0,
    marginHorizontal: 4,
    flex: 1,
    lineHeight: 16
  },
  'order-info-tracing': {
    overflow: 'hidden'
  },
  'order-info-status': {
    height: 18,
    lineHeight: 12,
    fontSize: 10,
    marginTop: 10,
    color: '#ee4d2d',
    paddingVertical: 2,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ee4d2d'
  },
  'order-info-time': {
    color: RNStyle.gray_3,
    fontSize: 12,
    marginTop: 4
  },
  'order-info-detail': {
    marginTop: 6,
    flexDirection: 'row',
    alignItems: 'center'
  },
  'order-info-detail-item': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    flex: 1.4
  }),
  'order-info-detail-price': {
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: 14,
    fontSize: 12,
    marginLeft: 'auto'
  },
  // &-price {
  //   margin-left: auto;
  //   color: rgba(0, 0, 0, 0.87);
  //   line-height: 0.875rem;
  //   font-size: 0.75rem;
  //   .ellipsis-text(1);
  //   span {
  //     font-weight: 400;
  //     font-size: 0.75rem;
  //     color: rgba(0, 0, 0, 0.54);
  //   }
  'order-info-detail-price-text': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.54)'
  }),
  'order-info-detail-status': {
    minHeight: 14,
    fontSize: 12,
    lineHeight: 14,
    color: '#ee4d2d',
    flex: 1.5
  },
  'order-info-detail-deliver-status': {
    minHeight: 14,
    fontSize: 12,
    lineHeight: 14,
    color: '#ee4d2d',
    flexBasis: 'auto',
    flexGrow: 0,
    flexShrink: 0,
    maxWidth: '50%',
    paddingRight: 4
  },
  'order-info-detail-deliver': {
    fontSize: 12,
    lineHeight: 14,
    flex: 1,
    textAlign: 'right',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  'order-info-wrap': {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12
  },
  'order-info-wrap-status': {
    minHeight: 14,
    fontSize: 12,
    lineHeight: 14,
    color: '#ee4d2d',
    flex: 1
  },
  'order-info-wrap-time': {
    color: RNStyle.gray_3,
    fontSize: 12,
    marginLeft: 'auto'
  },
  'order-info-wrap-select-btn': _objectSpread(_objectSpread({
    marginLeft: 'auto',
    minWidth: 52,
    maxWidth: 110,
    paddingVertical: 3,
    paddingHorizontal: 9,
    backgroundColor: '#ee4d2d',
    borderRadius: 2
  }, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 12,
    lineHeight: 19.2,
    color: '#ffffff',
    borderWidth: 0,
    textAlign: 'center'
  }),
  'sp-agent-upload-loader-status-icon': {
    position: 'absolute',
    width: 16,
    height: 16,
    bottom: 3,
    left: -20
  },
  // 以下是 ui 优化的样式
  'order-info-detail-item-ui-optimisation-hot-question': _objectSpread(_objectSpread({}, uiOptimisationPriceStyle), {}, {
    flex: 0
  }),
  'order-image-ui-optimisation-hot-question': {
    width: 56,
    height: 56,
    borderWidth: 0,
    borderRadius: 4
  },
  'order-image-ui-optimisation-hot-question-big': {
    width: 72,
    height: 72,
    borderWidth: 0,
    borderRadius: 4
  },
  'order-image-ui-optimisation-hot-question-icon': {
    width: '100%',
    height: '100%'
  },
  'order-container-ui-optimisation-hot-question': {
    padding: 10
  },
  'order-info-ui-optimisation-hot-question': {
    marginLeft: 8
  },
  'order-info-detail-price-text-ui-optimisation-hot-question': _objectSpread({}, uiOptimisationPriceStyle),
  'order-info-wrap-ui-optimisation-hot-question': {
    marginTop: 4
  },
  'order-info-detail-ui-optimisation-hot-question': {
    marginTop: 4
  },
  'order-info-wrap-status-ui-optimisation-hot-question': _objectSpread(_objectSpread({}, uiOptimisationPriceStyle), {}, {
    color: 'rgba(238, 77, 45, 1)'
  }),
  'order-info-name-ui-optimisation-hot-question': _objectSpread(_objectSpread({}, uiOptimisationPriceStyle), {}, {
    color: 'rgba(0, 0, 0, 0.87)',
    height: 'auto'
  }),
  'order-image-style-ui-optimisation-hot-question': {
    borderRadius: 4
  }
});